<div class="page-container">
    <header class="page-header">
        <div class="header-left">
            <h1>My Time Logs</h1>
            <p class="subtitle">Track your project hours</p>
        </div>
        <div class="header-right">
            <button (click)="toggleForm()" class="btn-primary">
                <i class="fa" [class.fa-plus]="!showForm" [class.fa-times]="showForm"></i>
                {{ showForm ? 'Cancel' : 'Log Time' }}
            </button>
        </div>
    </header>

    <div *ngIf="errorMessage" class="error-alert">
        {{ errorMessage }}
    </div>

    <!-- Time Log Forms Container -->
    <div *ngIf="showForm">
        <div *ngFor="let control of timeLogControls; let i = index" class="form-card" [style.marginBottom.rem]="1.5">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                <h3 style="margin: 0;">{{ editingLog ? 'Edit Time Log' : 'Log Your Time' }}</h3>
                <button *ngIf="!editingLog && timeLogControls.length > 1" type="button" (click)="removeLogEntry(i)"
                    class="btn-icon danger" title="Remove Entry">
                    <i class="fa fa-trash"></i>
                </button>
            </div>

            <form [formGroup]="control" (ngSubmit)="onSubmit(i, false)">
                <div class="form-row">
                    <div class="form-group third">
                        <label>Date *</label>
                        <input type="date" formControlName="date"
                            [class.invalid]="control.get('date')?.invalid && control.get('date')?.touched">
                    </div>

                    <div class="form-group third">
                        <label>Project *</label>
                        <select formControlName="projectId"
                            [class.invalid]="control.get('projectId')?.invalid && control.get('projectId')?.touched">
                            <option value="">Select a project</option>
                            <option *ngFor="let project of projects" [value]="project.id">
                                {{ project.name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group third" *ngIf="isHartisProject(control.get('projectId')?.value)">
                        <label>Task Type</label>
                        <select formControlName="taskType">
                            <option value="">Select type</option>
                            <option *ngFor="let type of taskTypes" [value]="type">
                                {{ type }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group third">
                        <label>
                            Duration *
                            <span *ngIf="control.get('date')?.value" class="remaining-badge"
                                >
                                ({{ formatMinutesToDuration(getLoggedHoursForDate(control.get('date')?.value,
                                control.get('id')?.value) * 60) }} logged)
                            </span>
                        </label>
                        <input type="text" formControlName="hours" placeholder="e.g., 1h 30m"
                            [class.invalid]="control.get('hours')?.invalid && control.get('hours')?.touched">
                        <small
                            *ngIf="control.get('hours')?.hasError('invalidDuration') && control.get('hours')?.touched"
                            class="error-text">
                            Invalid format
                        </small>
                    </div>
                </div>

                <div class="form-group">
                    <label>Description *</label>
                    <textarea formControlName="description" placeholder="Describe what you worked on" rows="1"
                        (input)="autoResizeTextarea($event)" style="overflow-y: hidden; min-height: 42px;"
                        [class.invalid]="control.get('description')?.invalid && control.get('description')?.touched"></textarea>
                </div>

                <div class="form-actions">
                    <button type="submit" [disabled]="control.invalid || isLoading" class="btn-primary">
                        <i class="fa fa-save"></i> {{ editingLog ? 'Save & Submit' : 'Submit Log' }}
                    </button>
                    <button type="button" (click)="onSubmit(i, true)" [disabled]="isLoading"
                        class="btn-secondary">
                        <i class="fa fa-file-text-o"></i> Save as Draft
                    </button>
                </div>
            </form>
        </div>

        <!-- Add New Log Button -->
        <div class="add-more-container" style="text-align: center; margin-bottom: 2rem;" *ngIf="!editingLog">
            <button type="button" (click)="addLogEntry()" class="btn-secondary" title="Add another log"
                style="border-radius: 50%; width: 50px; height: 50px; padding: 0; display: inline-flex; align-items: center; justify-content: center; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border: 2px solid var(--border-color);">
                <i class="fa fa-plus" style="font-size: 1.2rem;"></i>
            </button>
        </div>
    </div>

    <!-- Time Logs List -->
    <div *ngIf="isLoading && timeLogs.length === 0" class="loading-state">
        <div class="spinner"></div>
        <p>Loading time logs...</p>
    </div>

    <div *ngIf="!isLoading && timeLogs.length === 0" class="empty-state">
        <p>No time logs found. Start logging your time!</p>
    </div>

    <!-- Timeline View for Staff Data -->
    <div *ngIf="!isLoading && timelineData.length > 0" class="timeline-container">
        <div class="timeline-line"></div>
        <div *ngFor="let day of timelineData" class="timeline-item">
            <div class="timeline-dot" (click)="toggleDate(day)" [class.active]="day.expanded">
                <div class="inner-dot"></div>
            </div>
            <div class="timeline-content">
                <div class="date-header" (click)="toggleDate(day)">
                    <h3>{{ day.date | date:'fullDate' }}</h3>
                    <span class="expand-icon"><i class="fa"
                            [ngClass]="day.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
                </div>

                <div class="user-list" *ngIf="day.expanded">
                    <div *ngFor="let user of day.users" class="user-group-card" (click)="toggleUser(user, $event)">
                        <div class="user-header" [style.background]="user.color + '15'"
                            [style.border-left]="'4px solid ' + user.color">
                            <div class="user-info">
                                <div class="avatar-small" [style.background]="user.color">{{ user.avatarLetter }}</div>
                                <div class="user-details">
                                    <div class="user-name">Daily Summary</div>
                                    <div class="project-chips">
                                        <div *ngFor="let proj of user.projects" class="project-chip">
                                            <span class="chip-name">{{ proj.name }}</span>
                                            <span class="chip-duration">{{ proj.duration }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="user-meta">
                                <span class="total-duration" [style.color]="user.color"
                                    [style.background]="user.color + '15'">
                                    {{ user.totalDuration }}
                                </span>
                                <i class="fa" [ngClass]="user.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>
                        </div>

                        <!-- Logs List inside the User Card -->
                        <div class="user-tasks" *ngIf="user.expanded" (click)="$event.stopPropagation()">
                            <div *ngFor="let log of user.logs" class="task-item">
                                <div class="task-project">{{ getProjectName(log.projectId) }}</div>
                                <div class="task-desc">
                                    <span *ngIf="log.taskType" class="badge-type"
                                        style="margin-right: 8px; background: rgba(255,121,0,0.15); color: #ff7900; padding: 2px 6px; border-radius: 4px; font-size: 0.8em;">{{
                                        log.taskType }}</span>
                                    {{ log.description }}
                                </div>
                                <div class="task-duration">
                                    {{ log.displayDuration }}
                                    <span *ngIf="log.isDraft" class="badge-draft">Draft</span>
                                </div>
                                <div class="task-actions" *ngIf="log.isDraft">
                                    <button (click)="editLog(log)" class="btn-icon" title="Edit Draft">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button (click)="deleteLog(log.id)" class="btn-icon delete" title="Delete" style="margin-left: 10px;">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="infinite-scroll-status" *ngIf="isLoadingMore">
        <div class="spinner"></div>
        <span>Loading more logs...</span>
    </div>
</div>